import { createThemeFromColor } from './custom'

export const theme = createThemeFromColor('#1F2229', 'dark-gray', 'Xám đen')
